// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-voice-dialog',
//   templateUrl: './voice-dialog.component.html',
//   styleUrls: ['./voice-dialog.component.scss']
// })
// export class VoiceDialogComponent {

// }


import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-voice-dialog',
  templateUrl: './voice-dialog.component.html',
  styleUrls: ['./voice-dialog.component.scss']
})
export class VoiceDialogComponent implements AfterViewInit {
  @ViewChild('voiceCanvas', { static: false })
  canvasRef!: ElementRef<HTMLCanvasElement>;

  private ctx!: CanvasRenderingContext2D;

  ngAfterViewInit() {
    const canvas = this.canvasRef.nativeElement;
    this.ctx = canvas.getContext('2d')!;

    // Example: draw a circle
    this.ctx.fillStyle = 'limegreen';
    this.ctx.beginPath();
    this.ctx.arc(150, 100, 50, 0, Math.PI * 2);
    this.ctx.fill();

    // Example: draw text
    this.ctx.fillStyle = 'white';
    this.ctx.font = '20px Arial';
    this.ctx.fillText('Voice Dialog Canvas', 20, 250);
  }
}
